import React from 'react';
import { connect } from 'react-redux';

import * as opportunityActions from '../../actions/entities/OpportunitiesActions';
import { fetchCompanies } from '../../services/Api';
import OpportunityBuilderForm from '../../components/forms/OpportunityBuilderForm';

class OpportunityBuilderContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: []
    };
  }

  componentDidMount() {
    const { fetchOpportunity, resetCurrentOpportunity, match: { params: { postId } }, auth } = this.props;
    if (postId) {
      fetchOpportunity(postId);
    } else {
      resetCurrentOpportunity();
    }
    fetchCompanies(auth.access_token).then(res => this.setState({ companies: res.body.items }));
  }

  render() {
    const { opportunities: { currentOpportunity }, loading, match: { params: { postId } } } = this.props;
    if (!currentOpportunity || loading) {
      return null;
    }
    return (
      <div className={'flex flex1'}>
        <OpportunityBuilderForm post={postId ? currentOpportunity : null} companies={this.state.companies} />
      </div>
    );
  }
}

const mapStateToProps = ({ entities: { opportunities }, loader: { loading }, auth }) => ({ opportunities, loading, auth });

export default connect(mapStateToProps, opportunityActions)(OpportunityBuilderContainer);



// WEBPACK FOOTER //
// ./src/containers/private/OpportunityBuilderContainer.js